import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSecretService } from '../../shared/Services/data.service';
import { TemplateService } from '../../shared/Services/TemplateService.service';
import { CheckBoxOptions, DropdownOptions, MultiLingualTextBoxOptions, TextAreaOptions, TextBoxOptions } from 'bbsf-controls';
import { FormGroup } from '@angular/forms';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bbsf-utilities';

@Component({
  selector: 'lib-edit-template',
  templateUrl: './edit-template.component.html'
})
export class EditTemplateComponent implements OnInit {
  TemplateId: string = ""
  TemplateInfo: any
  IsAEditFormLoaded:boolean
// Decorator wires up blockUI instance

//Edit Model Controls
EditTemplateForm = new FormGroup({});
EditMultiLingualName:MultiLingualTextBoxOptions
EditSysName: TextBoxOptions;
EditDescriptionInEnglish: TextAreaOptions;
EditDescriptionInArabic: TextAreaOptions;
EditOrganization: DropdownOptions;
EditLanguageMode: DropdownOptions;
EditCategory: DropdownOptions;
EditMasterLayout: DropdownOptions;
IsEditTemplateFormLoaded: boolean;
EditIsEmail: CheckBoxOptions;
EditIsSms: CheckBoxOptions;
EditEnableIntensiveLogging: CheckBoxOptions;

constructor( private dataServices: DataSecretService, private authService: AuthService, private templateService: TemplateService, private activatedRoute: ActivatedRoute, private router: Router) {
  this.activatedRoute.params.subscribe(params => {
    this.TemplateId = params['id'];
  });}

  ngOnInit(): void {
  }


 
  
}
